import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import RequirePermission from '../components/RequirePermission';

// pages
import MarketBriefingScreen from '../screens/Market/MarketBriefingScreen';
import CapitalScreen from '../screens/Capital/CapitalScreen';
import SigninScreen from '../screens/Members/SigninScreen';
import SignupScreen from '../screens/Members/SignupScreen';
import VerifyEmailScreen from '../screens/Members/VerifyEmailScreen';
import ForgotScreen from '../screens/Members/ForgotScreen';
import ResetPasswordScreen from '../screens/Members/ResetPasswordScreen';
import TermsScreen from '../screens/Members/TermsScreen';
import PrivacyScreen from '../screens/Members/PrivacyScreen';
import ProfileScreen from '../screens/Members/ProfileScreen';
import NotFoundScreen from '../screens/NotFound/NotFoundScreen';
import DashboardScreen from '../screens/Dashboard/DashboardScreen';
import TransactionsScreen from '../screens/Transactions/TransactionsScreen';
import WalletScreen from '../screens/Wallet/WalletScreen';
import DataScreen from '../screens/Data/DataScreen';
import MyFavoritesScreen from '../screens/MyFavorites/MyFavoritesScreen';
import NotesTasksScreen from '../screens/NotesTasks/NotesTasksScreen';
import AlertSettingsScreen from '../screens/Settings/AlertSettingsScreen';
import TechnicalAlertsScreen from '../screens/Settings/TechnicalAlertsScreen';
import MessagesScreen from '../screens/Settings/MessagesScreen';
import ContactsScreen from '../screens/Settings/ContactsScreen';
import UpgradeScreen from '../screens/Settings/UpgradeScreen';
import PartnerSettings from '../screens/Settings/PartnerSettings';
import PaymentSuccessScreen from '../screens/Settings/PaymentSuccessScreen';
import AdminMessagesScreen from '../screens/Admin/AdminMessagesScreen';
import AdminSocietesScreen from '../screens/Admin/AdminSocietesScreen';
import MyAssetsScreen from '../screens/MyAssets/MyAssetsScreen';
import GlobalAnalysisScreen from '../screens/Analysis/GlobalAnalysisScreen';
import PortfolioAnalysisScreen from '../screens/Analysis/PortfolioAnalysisScreen';
import RebalancingScreen from '../screens/Analysis/RebalancingScreen';
import SwingTraderScreen from '../screens/Analysis/SwingTraderScreen';
import PrudentInvestorScreen from '../screens/Analysis/PrudentInvestorScreen';
import PepitesScreen from '../screens/Analysis/PepitesScreen';
import AlphaFusionScreen from '../screens/Analysis/AlphaFusionScreen';
import NiaPortfolioScreen from '../screens/Analysis/NiaPortfolioScreen';
import AiWatchlistScreen from '../screens/Analysis/AiWatchlistScreen';
import DocsScreen from '../screens/Docs/DocsScreen';
import CalendarScreen from '../screens/Calendar/CalendarScreen';
import CompanyResultsScreen from '../screens/Results/CompanyResultsScreen';
import ActualitesScreen from '../screens/Actualites/ActualitesScreen';
import PublicationsScreen from '../screens/Publications/PublicationsScreen';
import SpecialVraiPrixScreen from '../screens/SpecialVraiPrix/SpecialVraiPrixScreen';
import ConvergenceRadarScreen from '../screens/Admin/ConvergenceRadarScreen';
import ReportsPage from '../screens/Reports/ReportsPage';
import FinancialProjections from '../pages/FinancialProjections';
import LeaderboardScreen from '../screens/Leaderboard/LeaderboardScreen';
import ChatPage from '../screens/Chat/ChatPage';
import LandingPage from '../screens/Landing/LandingPage';
import BlogPage from '../screens/Landing/BlogPage';
import HelpCenterPage from '../screens/Landing/HelpCenterPage';
import OutilsPage from '../screens/Landing/OutilsPage';
import SponsorshipPage from '../screens/Sponsorship/SponsorshipPage';

// Forum Screens
import ForumScreen from '../screens/Forum/ForumScreen';
import ForumTopicScreen from '../screens/Forum/ForumTopicScreen';
import CreateTopicScreen from '../screens/Forum/CreateTopicScreen';

// New Admin Screens
import GlobalDashboard from '../screens/Admin/GlobalDashboard';
import TenantsScreen from '../screens/Admin/TenantsScreen';
import RolesScreen from '../screens/Admin/RolesScreen';
import PermissionsScreen from '../screens/Admin/PermissionsScreen';
import UserAdministration from '../screens/Admin/UserAdministration';
import LogsScreen from '../screens/Admin/LogsScreen';
import PaymentsPlansScreen from '../screens/Admin/PaymentsPlansScreen';
import MaintenanceScreen from '../screens/Admin/MaintenanceScreen';
import AzureMonitoringScreen from '../screens/Admin/AzureMonitoringScreen';
import AzureFunctionsScreen from '../screens/Admin/AzureFunctionsScreen';
import TenantDashboard from '../screens/tenant/TenantDashboard';
import TenantUsers from '../screens/tenant/TenantUsers';
import TenantRolesScreen from '../screens/tenant/TenantRolesScreen';
import TenantSettings from '../screens/tenant/TenantSettings';
import TenantNotificationsScreen from '../screens/tenant/TenantNotificationsScreen';
import TenantDetails from '../screens/Admin/TenantDetails';
import AdminUsersDetails from '../screens/Admin/AdminUsersDetails';
import RolesDetails from '../screens/Admin/RolesDetails';
import PermissionsDetails from '../screens/Admin/PermissionsDetails';
import AdminCotationsScreen from '../screens/Admin/AdminCotationsScreen';
import AdminDividendsScreen from '../screens/Admin/AdminDividendsScreen';
import AdminDiscoveredReportsScreen from '../screens/Admin/AdminDiscoveredReportsScreen';
import AdminDiscoveredAvisScreen from '../screens/Admin/AdminDiscoveredAvisScreen';
import AdminSocialPostsScreen from '../screens/Admin/AdminSocialPostsScreen';
import AdminLeaderboardExclusionsScreen from '../screens/Admin/AdminLeaderboardExclusionsScreen';
import AdminProposedArticlesScreen from '../screens/Admin/AdminProposedArticlesScreen';
import AdminEmailCampaignsScreen from '../screens/Admin/AdminEmailCampaignsScreen';
import AdminFundamentalsScreen from '../screens/Admin/AdminFundamentalsScreen';
import AdminFundamentalsDetailScreen from '../screens/Admin/AdminFundamentalsDetailScreen';
import AdminFundamentalsAnomaliesScreen from '../screens/Admin/AdminFundamentalsAnomaliesScreen';
import AdminSubscriptionsScreen from '../screens/Admin/AdminSubscriptionsScreen';
import AdminPromoCodesScreen from '../screens/Admin/AdminPromoCodesScreen';
import AdminReportsPage from '../screens/Admin/AdminReportsPage';
import AdminHolidaysScreen from '../screens/Admin/AdminHolidaysScreen';
import AdminLiveMarketScreen from '../screens/Admin/AdminLiveMarketScreen';
import AdminImportJournalScreen from '../screens/Admin/AdminImportJournalScreen';
import AdminOperationsTitresScreen from '../screens/Admin/AdminOperationsTitresScreen';
import AdminNiaDashboard from '../screens/Admin/AdminNiaDashboard';
import AdminCommissionsScreen from '../screens/Admin/AdminCommissionsScreen';
import AdminSessionAnomaliesScreen from '../screens/Admin/AdminSessionAnomaliesScreen';

// OPCVM & Obligations Screens
import OPCVMScreen from '../screens/OPCVM/OPCVMScreen';
import OPCVMDetailsScreen from '../screens/OPCVM/OPCVMDetailsScreen';
import ObligationsScreen from '../screens/Obligations/ObligationsScreen';
import ObligationDetailsScreen from '../screens/Obligations/ObligationDetailsScreen';

import { useParams } from 'react-router-dom';

const StockRedirect = () => {
  const { symbole } = useParams();
  return <Navigate to={`/data?symbol=${symbole}`} replace />;
};

const Navigation: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path='/home' element={<LandingPage />} />
      <Route path='/blog' element={<BlogPage />} />
      <Route path='/help' element={<HelpCenterPage />} />
      <Route path='/outils' element={<OutilsPage />} />
      <Route path='/login' element={<SigninScreen />} />
      <Route path='/signup' element={<SignupScreen />} />
      <Route path='/members/signup' element={<SignupScreen />} />
      <Route path='/members/forgot-password' element={<ForgotScreen />} />
      <Route path='/members/reset-password' element={<ResetPasswordScreen />} />
      <Route path='/verify-email' element={<VerifyEmailScreen />} />
      <Route path='/terms' element={<TermsScreen />} />
      <Route path='/confidentialite' element={<PrivacyScreen />} />

      {/* Root — landing si non connecté, dashboard si connecté */}
      <Route
        path='/'
        element={
          <ProtectedRoute>
            <DashboardScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/dashboard'
        element={
          <ProtectedRoute>
            <DashboardScreen />
          </ProtectedRoute>
        }
      />
      {/* Écrans du gabarit d'origine retirés (valeurs fictives) : on renvoie vers leurs équivalents réels */}
      <Route path='/market' element={<Navigate to='/cotations' replace />} />
      <Route path='/operations' element={<Navigate to='/my-assets' replace />} />
      {/* Anciennes URL présentes dans des e-mails déjà envoyés */}
      <Route path='/portfolio' element={<Navigate to='/my-assets' replace />} />
      <Route path='/signals' element={<Navigate to='/technical-alerts' replace />} />
      <Route path='/announcements' element={<Navigate to='/actualites' replace />} />
      <Route path='/ai-watchlists' element={<Navigate to='/ai-watchlist' replace />} />
      <Route path='/nia' element={<Navigate to='/chat' replace />} />
      <Route
        path='/market/briefing'
        element={
          <ProtectedRoute>
            <MarketBriefingScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/cotations'
        element={
          <ProtectedRoute>
            <CapitalScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/stock/:symbole'
        element={
          <ProtectedRoute>
            <StockRedirect />
          </ProtectedRoute>
        }
      />
      <Route
        path='/data'
        element={
          <ProtectedRoute>
            <DataScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/analysis'
        element={
          <ProtectedRoute>
            <GlobalAnalysisScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/docs'
        element={
          <RequirePermission permission='view_documentation'>
            <DocsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/calendar'
        element={
          <ProtectedRoute>
            <CalendarScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/resultats'
        element={
          <ProtectedRoute>
            <CompanyResultsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/actualites'
        element={
          <ProtectedRoute>
            <ActualitesScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/publications'
        element={
          <RequirePermission permission='admin_platform'>
            <PublicationsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/valuation'
        element={
          <RequirePermission permissions={['admin_platform', 'trader_experimental']}>
            <SpecialVraiPrixScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/convergence-radar'
        element={
          <RequirePermission permissions={['admin_platform', 'trader_experimental']}>
            <ConvergenceRadarScreen />
          </RequirePermission>
        }
      />
      {/* Doublons sans lien dans les menus : on garde l'URL, elle mène à l'écran de référence */}
      <Route path='/convergence-radar' element={<Navigate to='/admin/convergence-radar' replace />} />
      <Route path='/admin/users-legacy' element={<Navigate to='/admin/users' replace />} />
      <Route
        path='/reports'
        element={
          <ProtectedRoute>
            <ReportsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/financial-projections'
        element={
          <RequirePermission permissions={['admin_platform', 'trader_experimental']}>
            <FinancialProjections />
          </RequirePermission>
        }
      />

      {/* OPCVM Routes */}
      <Route
        path='/opcvm'
        element={
          <ProtectedRoute>
            <OPCVMScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/opcvm/:id'
        element={
          <ProtectedRoute>
            <OPCVMDetailsScreen />
          </ProtectedRoute>
        }
      />

      {/* Obligations Routes */}
      <Route
        path='/obligations'
        element={
          <ProtectedRoute>
            <ObligationsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/obligations/:symbole'
        element={
          <ProtectedRoute>
            <ObligationDetailsScreen />
          </ProtectedRoute>
        }
      />

      {/* Virtual Account */}
      <Route
        path='/wallet'
        element={
          <ProtectedRoute>
            <WalletScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/transactions'
        element={
          <ProtectedRoute>
            <TransactionsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/my-assets'
        element={
          <ProtectedRoute>
            <MyAssetsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/portfolio-analysis'
        element={
          <ProtectedRoute>
            <PortfolioAnalysisScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/rebalancing'
        element={
          <RequirePermission permission='trader_value'>
            <RebalancingScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/swing-trader'
        element={
          <ProtectedRoute>
            <SwingTraderScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/marketconfig/prudent'
        element={
          <RequirePermission permission='trader_prudent'>
            <PrudentInvestorScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/marketconfig/pepites'
        element={
          <RequirePermission permission='trader_pepites'>
            <PepitesScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/marketconfig/alpha-fusion'
        element={
          <RequirePermission permission='trader_alpha_fusion'>
            <AlphaFusionScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/nia-portfolio'
        element={
          <ProtectedRoute>
            <NiaPortfolioScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/ai-watchlist'
        element={
          <ProtectedRoute>
            <AiWatchlistScreen />
          </ProtectedRoute>
        }
      />
      {/* Redirects for old URLs */}
      <Route
        path='/swing-trader/prudent'
        element={<Navigate to='/marketconfig/prudent' replace />}
      />
      <Route
        path='/swing-trader/pepites'
        element={<Navigate to='/marketconfig/pepites' replace />}
      />
      <Route
        path='/favorites'
        element={
          <ProtectedRoute>
            <MyFavoritesScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/notes-taches'
        element={
          <ProtectedRoute>
            <NotesTasksScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/leaderboard'
        element={
          <ProtectedRoute>
            <LeaderboardScreen />
          </ProtectedRoute>
        }
      />

      <Route
        path='/chat'
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />

      {/* Forum */}
      <Route
        path='/forum'
        element={
          <ProtectedRoute>
            <ForumScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/forum/new'
        element={
          <ProtectedRoute>
            <CreateTopicScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/forum/topic/:id'
        element={
          <ProtectedRoute>
            <ForumTopicScreen />
          </ProtectedRoute>
        }
      />

      <Route
        path='/sponsorship'
        element={
          <ProtectedRoute>
            <SponsorshipPage />
          </ProtectedRoute>
        }
      />



      {/* Settings */}
      <Route
        path='/members'
        element={
          <ProtectedRoute>
            <ProfileScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/settings/alerts'
        element={
          <ProtectedRoute>
            <AlertSettingsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/technical-alerts'
        element={
          <ProtectedRoute>
            <TechnicalAlertsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/settings/messages'
        element={
          <ProtectedRoute>
            <MessagesScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/settings/contacts'
        element={
          <ProtectedRoute>
            <ContactsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/settings/partner'
        element={
          <ProtectedRoute>
            <PartnerSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path='/upgrade'
        element={
          <ProtectedRoute>
            <UpgradeScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path='/payment/success'
        element={
          <ProtectedRoute>
            <PaymentSuccessScreen />
          </ProtectedRoute>
        }
      />

      {/* Legacy Administration (Keep or Remove?) - Keeping for now */}
      <Route
        path='/admin/messages'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminMessagesScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/societes'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminSocietesScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/subscriptions'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminSubscriptionsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/promo-codes'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminPromoCodesScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/cotations'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminCotationsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/dividends'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminDividendsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/discovered-reports'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminDiscoveredReportsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/discovered-avis'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminDiscoveredAvisScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/social-posts'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminSocialPostsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/leaderboard-exclusions'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminLeaderboardExclusionsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/proposed-articles'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminProposedArticlesScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/email-campaigns'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminEmailCampaignsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/fundamentals'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminFundamentalsScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/fundamentals/:symbole'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminFundamentalsDetailScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/fundamentals-anomalies'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminFundamentalsAnomaliesScreen />
          </RequirePermission>
        }
      />
      <Route
        path='/admin/session-anomalies'
        element={
          <RequirePermission permission='admin_platform'>
            <AdminSessionAnomaliesScreen />
          </RequirePermission>
        }
      />

      {/* Admin Routes */}
      <>
        <Route
          path='/admin/dashboard'
          element={
            <RequirePermission permission='admin_platform'>
              <GlobalDashboard />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/tenants'
          element={
            <RequirePermission permission='admin_platform'>
              <TenantsScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/tenants/new'
          element={
            <RequirePermission permission='admin_platform'>
              <TenantDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/tenants/:id'
          element={
            <RequirePermission permission='admin_platform'>
              <TenantDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/roles'
          element={
            <RequirePermission permission='admin_platform'>
              <RolesScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/roles/new'
          element={
            <RequirePermission permission='admin_platform'>
              <RolesDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/roles/:id'
          element={
            <RequirePermission permission='admin_platform'>
              <RolesDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/permissions'
          element={
            <RequirePermission permission='admin_platform'>
              <PermissionsScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/permissions/new'
          element={
            <RequirePermission permission='admin_platform'>
              <PermissionsDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/permissions/:id'
          element={
            <RequirePermission permission='admin_platform'>
              <PermissionsDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/users'
          element={
            <RequirePermission permission='admin_platform'>
              <UserAdministration />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/users/:id'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminUsersDetails />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/logs'
          element={
            <RequirePermission permission='admin_platform'>
              <LogsScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/payments'
          element={
            <RequirePermission permission='admin_platform'>
              <PaymentsPlansScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/maintenance'
          element={
            <RequirePermission permission='admin_platform'>
              <MaintenanceScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/monitoring'
          element={
            <RequirePermission permission='admin_platform'>
              <AzureMonitoringScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/azure-functions'
          element={
            <RequirePermission permission='admin_platform'>
              <AzureFunctionsScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/reports-audit'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminReportsPage />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/holidays'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminHolidaysScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/marche-live'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminLiveMarketScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/journal-imports'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminImportJournalScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/operations-titres'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminOperationsTitresScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/nia'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminNiaDashboard />
            </RequirePermission>
          }
        />
        <Route
          path='/admin/commissions'
          element={
            <RequirePermission permission='admin_platform'>
              <AdminCommissionsScreen />
            </RequirePermission>
          }
        />

        {/* Tenant Admin Routes */}
        <Route
          path='/tenant/dashboard'
          element={
            <RequirePermission permission='manage_tenant_settings'>
              <TenantDashboard />
            </RequirePermission>
          }
        />
        <Route
          path='/tenant/users'
          element={
            <RequirePermission permission='manage_tenant_settings'>
              <TenantUsers />
            </RequirePermission>
          }
        />
        <Route
          path='/tenant/roles'
          element={
            <RequirePermission permission='manage_tenant_settings'>
              <TenantRolesScreen />
            </RequirePermission>
          }
        />
        <Route
          path='/tenant/settings'
          element={
            <RequirePermission permission='manage_tenant_settings'>
              <TenantSettings />
            </RequirePermission>
          }
        />
        <Route
          path='/tenant/notifications'
          element={
            <RequirePermission permission='manage_tenant_settings'>
              <TenantNotificationsScreen />
            </RequirePermission>
          }
        />
      </>

      {/* 404 */}
      <Route path='*' element={<NotFoundScreen />} />
    </Routes>
  );
};

export default Navigation;
